<template>
    <div class="pro-pic inner-upload-single">
        <transition-group tag="div" class="drag-wrap">
            <div class="drag-item" v-for="(file,index) in imgFileNew" :key="file.url"
                 draggable="true"
                 @dragstart="handleDragStart($event, file)"
                 @dragover.prevent="handleDragOver($event, file)"
                 @dragenter="handleDragEnter($event, file)"
                 @dragend="handleDragEnd($event, file)">
                <div
                    class="img-box"
                    :class="{ borderColorChange:file.url }"  :style="'width:'+width+'px;height:'+height+'px'">
                    <div v-if="file.url">
                        <el-image
                            class="avatar" ref="proPic"
                            :src="file.url"
                            :preview-src-list="srcList" :style="'width:'+width+'px;height:'+height+'px'">
                        </el-image>
                    </div>
                    <div v-if="file.url && !dragging" class="img-cover-wrap">
                        <i @click.stop="del(index)" class="el-icon-error"></i>
                    </div>
                </div>
            </div>
        </transition-group>
        <el-upload
            class="avatar-uploader"
            action="/service-center/upload/file/single"
            :headers="headers"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess">
            <el-button>{{buttonName}}</el-button>
        </el-upload>
    </div>
</template>

<script>
    export default {
        name: "uploadMultiImage",
        props: {
            imgFile: {
                type: Array,
                default: () => []
            },
            buttonName: {
                type: String,
                default: '点击上传'
            },
            width: {
                type: String,
                default: '275'
            },
            height: {
                type: String,
                default: '200'
            }
        },
        data() {
            return {
                dragging: null,
                imgFileNew: [],
                headers: {
                    'Authorization': 'Bearer ' +  $cookies.get("api_access_token")
                },
                srcList: []
            }
        },
        watch:{
            imgFileNew (newVal) {
                if(newVal){
                    this.srcList = []
                    newVal.map((item)=>{
                        this.srcList.push(item.url)
                    })
                } else {
                    this.srcList = []
                }
              
            },
            imgFile: {
                handler(val) {
                    if(val){
                        this.imgFileNew = val
                        this.srcList = []
                        val.map((item)=>{
                            this.srcList.push(item.url)
                        })
                    } else {
                        this.imgFileNew = []
                        this.srcList = []
                    }
                },
                immediate: true,
                deep: true
            },
        },
        computed: {
            accept() {
                return 'image/jpeg,image/jpg'
            }
        },
        methods: {
            handleAvatarSuccess(res, file) {
                this.imgFileNew.push(res)
                this.srcList.push(res.url)
                this.$emit('avatarChange', this.imgFileNew)
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type.indexOf('image') !== -1;
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.warning('上传图片只能是图片格式!');
                }
                if (!isLt2M) {
                    this.$message.warning('上传图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },
            del(index) {
                this.imgFileNew[index].url = ''
                this.imgFileNew.splice(index,1)
                this.srcList.splice(index,1)
                this.$emit('deleteImg', this.imgFileNew)
            },
            handleDragStart(e, item) {
                this.dragging = item
            },
            handleDragEnd(e, item) {
                this.dragging = null
            },
            handleDragOver(e) {
                e.dataTransfer.dropEffect = 'move'
            },
            handleDragEnter(e, item) {
                e.dataTransfer.effectAllowed = "move" //为需要移动的元素设置dragstart事件
                if (item === this.dragging) {
                    return
                }
                const newItems = [...this.imgFileNew]
                const src = newItems.indexOf(this.dragging)
                const dst = newItems.indexOf(item)
                newItems.splice(dst, 0, ...newItems.splice(src, 1))
                this.imgFileNew = newItems
                this.$emit('getDragImgFile', newItems)
            }
        }
    }
</script>

<style lang="less" scoped>
    button{
        width: 100px;
        background: #3d7fff;
        border: none;
        border-radius: 5px;
        font-size: 14px;
        color: #FFFFFF;
    }
    .container{
        width: 80px;
        height: 300px;
        position: absolute;
        left: 0;
        display:flex;
        flex-direction: column;
        padding: 0;
    }
    .item {
        margin-top: 10px;
        transition: all linear .3s
    }
    .drag-wrap {
        display: flex;
        flex-wrap: wrap;
        .drag-item {
            margin-right: 13px;
            margin-bottom: 13px;
            cursor: pointer;
            &:hover{
                .img-cover-wrap{
                    display: block;
                }
            }
            &:last-child {
                margin-right: 0;
            }
        }
    }
    .avatar-uploader-icon {
        color: #409eff;
        width: 275px;
        height: 200px;
        text-align: center;
        vertical-align: middle;
        display: table-cell;
        text-align: center;
        font-size: 12px;
        border: 1px dashed #ddd;
    }
    
    img {
        width:100%;
        height: 100%;
        display: block;
    }
    /deep/.el-image__preview{
        width: 100%;
        height: 100%;
    }
    .img-empty {
        vertical-align: sub;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    
    .img-box {
        width: 100%;
        height: 100%;
        background-color: #f9fcff;
        border: dashed 1px #409eff;
        float: left;
        margin-right: 13px;
        position: relative;
    }
    
    .img-box:last-child {
        margin-right: 0;
    }
    
    .borderColorChange {
        border: solid 1px #ececec;
        background-color: #f9f9f9;
    }
    
    .el-icon-plus:before {
        content: "";
    }
    
    // 删除
    .img-cover-wrap {
        right: 5px;
        top: 5px;
        position: absolute;
        line-height: initial;
        display: none;
        i {
            font-size: 22px;
            color: #000;
            display: inline;
            cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/uploadImage/index.vue